import axios from "axios";

// Backend is reached via the SAME ORIGIN that serves the frontend. The Emergent
// ingress (preview, production deploy, and custom domains) routes every
// `/api/*` request to the FastAPI pod, so a relative path works in all
// environments and avoids the classic "REACT_APP_BACKEND_URL was baked at
// build time and points to the wrong host after deploy" issue.
export const API_BASE = "/api";

export const api = axios.create({
  baseURL: API_BASE,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("b2b_token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export function formatApiError(err) {
  const d = err?.response?.data?.detail;
  if (d == null) return err?.message || "Niečo sa pokazilo";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((e) => e?.msg || JSON.stringify(e)).join(" ");
  if (typeof d === "object" && d.msg) return d.msg;
  return String(d);
}

// EUR-only formatter. Extra args are ignored for backwards compatibility
// with legacy call-sites that still pass a native-HUF value.
export function formatMoney(n /* , _nativeHufIgnored */) {
  if (n == null || isNaN(n)) return "—";
  return `€${Number(n).toFixed(2)}`;
}

/**
 * Format a money value that has already been recorded on an order.
 * Orders now always store EUR — the `currency` argument is accepted for
 * backwards compatibility with older order documents but is ignored.
 */
export function formatOrderMoney(n /* , _currencyIgnored */) {
  if (n == null || isNaN(n)) return "—";
  return `€${Number(n).toFixed(2)}`;
}
